<template>
  <router-view />
  <LoadingSAP v-if="this.$store.state.loading" />
  <Loading v-if="this.$store.state.loadingPattern" />
  <LoadingProgress v-if="this.$store.state.loadingPatternProgress.status"
    :progress="this.$store.state.loadingPatternProgress.progress"
    :loading="this.$store.state.loadingPatternProgress.loading"
    :total="this.$store.state.loadingPatternProgress.total" />
</template>

<script>
import LoadingSAP from "./components/LoadingSAP.vue";
import Loading from "./components/Loading.vue";
import LoadingProgress from "./components/LoadingProgress.vue";

export default {
  name: "App",
  components: {
    LoadingSAP,
    Loading,
    LoadingProgress,
  },
};
</script>